import React from "react";
import Icon from "components/common_components/Icon";

const SUPPORT_URL = "https://amp-operations-platform.vercel.app/";

function FloatingSupport() {
    const openSupport = () => {
        window.open(SUPPORT_URL, "_blank", "noopener,noreferrer");
    };

    return (
        <div className="floating-support" title="Support" onClick={openSupport}>
            <Icon name="question" size="sm" color="white" />
            <span className="floating-support__label">Support</span>
        </div>
    );
}

export default FloatingSupport;
